module.exports = __webpack_public_path__ + "assets/img/lx_product_t.61a9b0ac.png";